<template>
  <div id="SealApprove">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="search">
      <el-form ref="dialogfref" :model="dialogform" label-width="96px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="申请人" prop="ApplicantName">
              <el-input
                clearable
                v-model="dialogform.ApplicantName"
                placeholder="请输入申请人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="录入人" prop="PostName">
              <el-input
                clearable
                v-model="dialogform.PostName"
                placeholder="请输入录入人"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="申请时间">
              <el-date-picker
                class="select"
                v-model="dialogform.StartTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="申请时间">
              <el-date-picker
                class="select"
                v-model="dialogform.EndTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="用章类型" prop="SealType">
              <el-select
                v-model="dialogform.SealType"
                placeholder="请选择"
                class="select"
                clearable
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="用章申请状态" prop="Status">
              <el-select v-model="dialogform.Status" placeholder="请选择">
                <el-option
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  clearable
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label-width="0">
              <div class="btn">
                <el-button type="primary" @click="searchseal()">搜索</el-button>
                <el-button @click="reset('dialogfref')">重置</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="applicantName" label="申请人姓名">
        </el-table-column>
        <el-table-column prop="reason" label="申请事由"> </el-table-column>
        <el-table-column prop="sealType" label="用章类型" width="140">
          <template slot-scope="scope">
            <span>{{ getSealLabels(scope.row.sealType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="postTime" label="申请时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.postTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="sealtime" label="用印时间">
        </el-table-column> -->
        <el-table-column label="当前状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" type="text" class="spz"
              >审批中</span
            >
            <span
              v-if="scope.row.result == 1 && scope.row.status == 0"
              type="text"
              class="fail"
              >被驳回</span
            >
            <span
              v-if="scope.row.result == 0 && scope.row.status == 0"
              type="text"
              class="success"
              >通过</span
            >
            <span v-if="scope.row.status == -1" type="text" class="del"
              >已撤销</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="210">
          <template slot-scope="scope">
            <el-button
              class="tg"
              size="small"
              @click="approval(scope.row.id, 0)"
              v-if="
                $store.state.rolesname.includes('SealApprove_pass') &&
                scope.row.isapprover
              "
              >通过</el-button
            >
            <el-button
              class="bh"
              size="small"
              @click="approval(scope.row.id, 1)"
              v-if="
                $store.state.rolesname.includes('SealApprove_refuse') &&
                scope.row.isapprover
              "
              >驳回</el-button
            >
            <el-button
              class="look"
              size="small"
              @click="Look(scope.row)"
              v-if="$store.state.rolesname.includes('SealApprovedetail')"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="bank_pagination">
        <el-pagination
          :hide-on-single-page="value"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-if="bPageShow"
        />
      </div>
    </div>

    <!--更多选择!-->
    <el-dialog
      title="搜索"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
    >
      <el-form ref="dialogfref" :model="dialogform" label-width="96px">
        <el-form-item label="申请人" prop="ApplicantName">
          <el-input
            v-model="dialogform.ApplicantName"
            placeholder="请输入要查找的申请人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="录入人" prop="PostName">
          <el-input
            v-model="dialogform.PostName"
            placeholder="请输入要查找的录入人姓名"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请时间">
              <el-date-picker
                class="select"
                v-model="dialogform.StartTime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10px">
              <el-date-picker
                class="select"
                v-model="dialogform.EndTime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用章类型" prop="SealType">
              <el-select
                v-model="dialogform.SealType"
                placeholder="请选择用章类型"
                class="select"
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用章申请状态" prop="Status">
              <el-select
                v-model="dialogform.Status"
                placeholder="请选择用章申请状态"
              >
                <el-option
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label-width="0">
          <div class="btn">
            <el-button type="primary" @click="searchseal()">搜索</el-button>
            <el-button @click="reset('dialogfref')">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="approvaldialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="failform"
          label-width="80px"
          ref="failformref"
          :rules="failformrules"
        >
          <el-form-item prop="Reason" label="驳回原因">
            <el-input
              v-model="failform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div class="refuse">
          <el-button @click="refuse('failformref')" type="primary"
            >驳回</el-button
          >
        </div>
      </div>
      <div class="success" v-else>
        <div><img src="../../assets/success.svg" /></div>
        <div class="pass">已通过</div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { Seal, SealSuccess, SealReject } from '../../api/examine'
var reason = (rule, value, callback) => {
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (value.match(/^[ ]*$/)) {
      callback(new Error('驳回原因不能为空'))
    }
  }
  callback()
}
export default {
  name: 'SealApprove',
  data() {
    return {
      bPageShow: true,
      isLoading: false,
      next: false, //是否是三级菜单
      Con: '',
      more: '',
      dialogVisible: false,
      dialogform: {
        ApplicantName: '',
        PostName: '',
        SealType: '',
        Status: null,
        StartTime: null,
        EndTime: null
      },
      Status: [
        { label: '已通过', value: 0 },
        { label: '待审核', value: 1 },
        { label: '被驳回', value: 2 },
        { label: '已撤销', value: 4 }
      ],
      // CaseType:[{ label: "已通过", value: 0 }, { label: "一审", value: 1 }],
      dialogVisible: false, //弹出框
      IsorNo: [
        { label: '是', value: 0 },
        { label: '否', value: 1 }
      ],
      Casetype: [
        { label: '民事案件', value: '民事案件' },
        { label: '破产案件', value: '破产案件' }
      ],
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],
      //合同用章
      tableData: [],
      PageSizes: [10, 20, 50, 100],
      // PageSizes: [1, 2, 5, 10],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      value: false, //只有一页的时候隐藏分页
      //审核弹出框
      approvaldialog: false,
      title: '',
      failform: {},
      failformrules: {
        Reason: [
          { required: true, message: '驳回原因不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    getSealLabels(sealType) {
      return sealType
        .map((type) => {
          const seal = this.seal.find((s) => s.value === type)
          return seal ? seal.label : type
        })
        .join(', ')
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    searchseal() {
      this.PageIndex = 1
      this.Search()
    },
    handleCancle() {
      if (this.title != '') {
        this.$refs.failformref.resetFields()
      }
    },
    Search() {
      //获取审核数据
      this.isLoading = true
      var starttime = null
      var endtime = null
      if (this.dialogform.StartTime) {
        starttime = this.JsonTime(this.dialogform.StartTime)
      }
      if (this.dialogform.EndTime) {
        endtime = this.JsonTime(this.dialogform.EndTime)
      }
      Seal({
        page: this.PageIndex,
        rows: this.PageSize,
        SealType: this.dialogform.SealType,
        ApplicantName: this.dialogform.ApplicantName,
        PostName: this.dialogform.PostName,
        Status: this.dialogform.Status,
        StartTime: starttime,
        EndTime: endtime
      }).then((res) => {
        if (res.data.status == 'success') {
          this.tableData = res.data.data

          this.Total = res.data.total
          this.dialogVisible = false
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
        this.isLoading = false
      })
    },
    reset() {
      this.dialogform.SealType = ''
      this.dialogform.ApplicantName = ''
      this.dialogform.PostName = ''
      this.dialogform.StartTime = null
      this.dialogform.EndTime = null
      this.dialogform.Status = null
      this.searchseal()
    },
    approval(id, type) {
      //审核
      var header = document.getElementsByClassName('el-dialog__header')
      if (type == 0) {
        //通过
        this.isLoading = true
        SealSuccess({ Id: id }).then((res) => {
          if (res.data.status == 'success') {
            this.title = ''
            header[1].style.display = 'none'
            this.approvaldialog = true
            this.$message.success('审核成功')
            this.Search()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      }
      if (type == 1) {
        this.title = '驳回原因'
        header[1].style.display = ''
        this.approvaldialog = true
        this.failform.id = id
      }
    },
    refuse(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          SealReject({
            Id: this.failform.id,
            Reason: this.failform.Reason
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('审核成功')
              this.Search()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
          this.approvaldialog = false
        } else {
          this.$message.error('有必填项为空！')

          return false
        }
      })
    },
    Look(row) {
      //查看
      this.$router.push({
        path: '/home/seal/SealApprovedetail',
        query: {
          guid: row.id,
          dayin: row.isapprover ? 0 : 1
        }
      })
    },
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogVisible = true
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.Search()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.Search()
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    // --时间格式转换--
    formatTime(row) {
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      if (hours == '00' && minutes == '00' && seconds == '00') {
        return year + '-' + month + '-' + day
      } else {
        return (
          year + '-' + month + '-' + day
          // +
          // ' ' +
          // hours +
          // ':' +
          // minutes +
          // ':' +
          // seconds
        )
      }
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    }
  },
  created() {
    this.getvalue()
    // this.Search()
  },
  beforeRouteLeave(to, from, next) {
    const type = 'SealApprovePage'
    if (to.name == 'SealApprovedetail') {
      var con = {
        form: this.dialogform,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      }
      this.$store.dispatch('saveSearchCondition', { type, condition: con }) //保存
    } else {
      this.$store.dispatch('clearSearchConditions', type) //保存
    }

    next()
  },
  beforeRouteEnter(to, from, next) {
    // 辅助函数，用于在组件实例化之前执行一些代码
    function fetchData() {
      const type = 'SealApprovePage'
      // console.log("获取")
      // 从 Vuex store 中读取搜索条件
      if (this.$store.state.searchConditions[type]) {
        return this.$store.state.searchConditions[type]
      }
      return null
    }
    // 通过 next 回调访问组件实例
    next((vm) => {
      const fetchedData = fetchData.call(vm)
      if (fetchedData && from.name == 'SealApprovedetail') {
        vm.dialogform = fetchedData.form
        vm.PageIndex = fetchedData.PageIndex
        vm.PageSize = fetchedData.PageSize
        // console.log(fetchedData.PageIndex)
        vm.bPageShow = false
        vm.$nextTick(() => {
          vm.bPageShow = true
        })
        vm.Search()
      } else {
        vm.Search()
      }
    })
  }
}
</script>
  
<style lang="less" scoped>
// 查询
.search {
  box-sizing: border-box;
  width: 100%;
  // margin: auto;
  // display: flex;

  padding: 20px;
  // margin-bottom: 24px;
}

.search ::v-deep .el-input__inner {
  // width: 80% !important;
  // width: 300px;
  background-color: #fafafa;
  border: 0 !important;
  border-radius: 12px;
}

.nameSearch {
  width: 24vw;
  margin-right: 10px;
}

// .select {
//   width: 10vw;
//   margin-right: 10px;
// }

// 弹出框
/deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

//表格
.casestatus {
  color: rgba(254, 150, 74, 1);
}

.btn {
  width: 100%;
  text-align: center;
}

.tg {
  background: #e7f7ef;
  border-radius: 8px;
  color: #0caf60;
  border: none;
}

.bh {
  background: #fff0e6;
  border-radius: 8px;
  color: #fe964a;
  border: none;
}

.look {
  background: #eff5ff;
  border-radius: 8px;
  color: #3077e6;
  border: none;
}

// 分页
.bank_pagination {
  text-align: right;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

/deep/.el-pagination__total {
  float: left;
}

/deep/.el-pagination__sizes {
  float: left;
}

// 弹出框
#SealApprove /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#SealApprove .success {
  width: 100%;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
}

#SealApprove .pass {
  color: #718096;
  font-size: 24px;
  margin-top: 12px;
}

#SealApprove .success {
  color: #3077e6;
}

#SealApprove .spz {
  color: #0caf60;
}

#SealApprove .fail {
  color: #fe964a;
}

#SealApprove .del {
  color: red;
}

#SealApprove .refuse {
  width: 100%;
  text-align: center;
}
</style>
  